import { ChevronRightIcon } from "assets";
import classNames from "classnames";
import styles from "./rotatable-chevron.module.scss";

interface Props {
  isOpen: boolean;
}

export const RotatableChevron = ({ isOpen }: Props) => {
  return (
    <ChevronRightIcon
      className={classNames(styles.chevron, isOpen && styles.open)}
    />
  );
};
